import React from "react";

const FiterIcon = ({
  className,
  fill = "none",
  height = 30,
  width = 30,
  stroke
}: FilterIconProps) => (
  <svg width={width} height={height} viewBox="0 0 18 18" className={className}>
    <path
      fill={fill}
      stroke={stroke}
      strokeWidth={1}
      d="M7.45 17.248h3.1v-7.73L16.98.75H1.02l6.43 8.768v7.73zm3.653-7.55v8.103H6.897V9.699L-.071.197h18.142L11.103 9.7z"
    />
  </svg>
);

export default FiterIcon;

interface FilterIconProps {
  className?: string;
  fill?: string;
  height?: number;
  stroke?: string;
  width?: number;
}
